import { motion } from "framer-motion";

function CornerCard() {
  return (
    <div className="relative overflow-hidden w-full max-w-[440px]">
      <svg width="470" height="228" viewBox="0 0 470 228" fill="none" className="absolute top-0 left-0">
        <path d="M469.5 227.5V0.5H40.207L0.5 40.207V227.5H469.5Z" fill="#1a1a1a" />
        <motion.path 
          d="M469.5 227.5V0.5H40.207L0.5 40.207V227.5H469.5Z" 
          fill="none" 
          stroke="white" 
          strokeWidth="1"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 1.0,
            delay: 0.7,
            ease: "easeInOut"
          }}
        />
      </svg>
      <div className="px-4 pt-8 pb-4 md:p-12 text-left text-sm lg:text-lg text-white relative overflow-hidden">
        <div className="relative z-10">
          Blackbird operates at the edge of possibility — where innovation is
          silent, speed is survival, and compromise is failure.
        </div>
      </div>
    </div>
  );
}

export default CornerCard;